import * as moment from 'moment';
import Person from '../Person/Person';

class Insight {
  constructor(contentfulNode, defaultBG) {
    this.category = contentfulNode?.category?.title ?? contentfulNode?.fields?.category?.fields?.title ?? 'Category';
    this.authors = contentfulNode?.fields?.authors ?
      contentfulNode.fields.authors.map(person => new Person(person)) :
      contentfulNode?.authors ?
        contentfulNode?.authors?.map(person => new Person(person)) :
        [];
    this.id = contentfulNode?.id;
    this.title = contentfulNode?.title ?? contentfulNode?.fields?.title ?? 'Insight Title';
    this.type = contentfulNode?.type ?? contentfulNode?.fields?.type;
    this.slug = contentfulNode?.slug ?? contentfulNode?.fields?.slug;
    this.localizationSlug = contentfulNode?.localizationSlug;
    this.snippet = contentfulNode?.snippet?.snippet ?? contentfulNode?.snippet ?? contentfulNode?.fields?.snippet ?? 'Insight Snippet';
    this.publishDate = contentfulNode?.publishDate ?? contentfulNode?.fields?.publishDate;
    this.displayDate = contentfulNode?.displayDate;
    this.createdAt = contentfulNode?.createdAt;
    this.updatedAt = contentfulNode?.updatedAt;
    this.blogRichJSON = contentfulNode?.insightContent ?? '';
    this.heroImageData = {
      title: contentfulNode?.title,
      fluid: contentfulNode?.heroImage?.gatsbyImageData,
      url: contentfulNode?.fields?.heroImage?.fields?.file?.url
    };
    this.heroDefaultImageData = {
      title: 'Default image background',
      fluid: defaultBG?.childImageSharp.gatsbyImageData
    };
    this.featuredContentTitle = contentfulNode?.featuredContentTitle;
    this.featuredContentHeroImage = {
      title: contentfulNode?.featuredContentTitle,
      fluid: contentfulNode?.featuredContentHeroImage?.gatsbyImageData,
      url: contentfulNode?.fields?.featuredContentHeroImage?.file?.url
    };
    this.indexAuthors = contentfulNode?.indexAuthors ?? '';
    this.indexBody = contentfulNode?.indexBody ?? '';
    this.metaTitle = contentfulNode?.metaTitle;
    this.metaDescription = contentfulNode?.metaDescription?.internal?.content ?? '';
    this.requireContentForm = contentfulNode?.requireContentForm ?? false;
    this.contentTitle = contentfulNode?.contentTitle ?? null;
    this.downloadableContent = {
      url: contentfulNode?.downloadableContent?.file?.url,
      fileName: contentfulNode?.downloadableContent?.file?.fileName,
      contentType: contentfulNode?.downloadableContent?.file?.contentType
    };
    this.completedFormPrompt = contentfulNode?.completedDownloadPrompt;
    this.podcastAudio = contentfulNode?.podcastAudio;
    this.relatedInsights = contentfulNode?.relatedInsights
      ? contentfulNode?.relatedInsights.map(insight => new Insight(insight))
      : null;
    this.tags = contentfulNode?.tags ?? [];
    this.videoEmbedUrl = contentfulNode?.videoContent?.embedUrl;
    this.redirectContentUrl = contentfulNode?.redirectContent;
    this.clientSuccessImage = contentfulNode?.clientSuccessImage;
    this.customForm = contentfulNode?.customForm;
  }

  /**
   * Getter which receives a moment-compliant format string and returns
   * the Insights publishDate by applying the given format
   *
   * @function getFormattedPublishDate
   * @param {string} formatString Moment-compliant format string -> https://momentjs.com/docs/#/displaying/format/
   * @returns {string} Formatted date string
   */
  getFormattedPublishDate = formatString => {
    return moment(this.publishDate, 'YYYY-MM-DD').format(formatString);
  };

  /**
   * Getter which receives a moment-compliant format string and returns
   * the Insights updatedAt applying the given format
   *
   * @function getFormattedModificationDate
   * @param {string} formatString Moment-compliant format string -> https://momentjs.com/docs/#/displaying/format/
   * @returns {string} Formatted date string
   */
  getFormattedModificationDate = formatString => {
    return moment(this.updatedAt).format(formatString);
  };

  /**
   * Getter which receives a moment-compliant format string and returns
   * the Insights createdAt by applying the given format
   *
   * @function getFormattedCreationDate
   * @param {string} formatString Moment-compliant format string -> https://momentjs.com/docs/#/displaying/format/
   * @returns {string} Formatted date string
   */
  getFormattedCreationDate = formatString => {
    return moment(this.createdAt).format(formatString);
  };
}

export default Insight;
